<template>
  <v-app-bar class="wrapper-app-bar">
    <v-container
      class="wrapper-toolbar pa-0"
      :style="{ left: $vuetify.rtl ? '0' : '', right: !$vuetify.rtl ? '0' : '' }"
    >
      <!--TOGGLE-BTN-->
      <div class="toggle-btn">
        <div
          class="d-flex align-center toggle-icon"
          :class="{ rotate: isMenuToggle }"
          @click="menuToggle"
        >
          <my-icon
            :name="'toggle-icon'"
            :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
            :width="18"
            :height="18"
            :cursor-pointer="true"
          />
        </div>
      </div>
      <div class="d-flex align-center gap-3">
        <v-btn
          min-width="0"
          text
          small
          style="direction: rtl"
          color=""
          class="pa-0"
        >
          {{ today }}
        </v-btn>
        <v-menu bottom offset-y transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="0"
              text
              small
              v-bind="attrs"
              color=""
              :loading="loading"
              v-on="on"
              @click="getYears"
              class="pa-0"
            >
              {{ $t("Year") }} : {{ $store.state.year }}
            </v-btn>
          </template>
          <v-list :tile="false" nav>
            <v-list-item
              v-for="(year, i) in yearItems"
              :key="i"
              style="cursor: pointer"
              dense
              @click="changeYear(year)"
            >
              <v-list-item-title>{{ year.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="vertical-divider"></div>
        <div class="d-flex align-center gap-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                @click="resize"
                style="width: auto; height: auto"
              >
                <my-icon
                  :name="'resize-icon'"
                  :fill="$vuetify.theme.isDark ? '#fff' : '#000'"
                  :width="18"
                  :height="18"
                  :cursor-pointer="true"
                />
              </v-btn>
            </template>
            <span>{{ $t("change-page-size") }}</span>
          </v-tooltip>
          <Updates />
          <TemplateSetting />
        </div>
        <div class="vertical-divider"></div>
        <div class="d-flex align-center gap-3">
          <UserConversation />
          <UserFileProcess />
          <UserHelp />
          <UserSupport />
          <UserHistory />
        </div>
        <div class="vertical-divider"></div>
        <UserPlan />
        <UserData />
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import UserData from "@/views/dashboard/components/core/appbar/partial/UserData.vue";
import UserHelp from "@/views/dashboard/components/core/appbar/partial/UserHelp.vue";
import UserSupport from "@/views/dashboard/components/core/appbar/partial/UserSupport.vue";
// Redesigned notification center (UserHistory.vue kept untouched)
import UserHistory from "@/views/dashboard/components/core/appbar/partial/NotificationCenter.vue";
import UserConversation from "@/views/dashboard/components/core/appbar/partial/UserConversation.vue";
import UserFileProcess from "@/views/dashboard/components/core/appbar/partial/UserFileProcess.vue";
// Redesigned theme settings (TemplateSetting.vue kept untouched)
import TemplateSetting from "@/views/dashboard/components/core/appbar/partial/theme/ThemeSettingsButton.vue";
import Updates from "@/views/dashboard/components/core/appbar/partial/Updates.vue";
import moment from "moment-jalaali";
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
import UserPlan from "@/views/dashboard/components/core/appbar/partial/UserPlan.vue";

export default {
  name: "AppBarDesktop",
  data() {
    return {
      isMenuToggle: false,
      today: null,
      yearItems: [],
      loading: false,
    };
  },
  components: {
    UserData,
    UserHelp,
    UserSupport,
    UserHistory,
    UserConversation,
    UserFileProcess,
    TemplateSetting,
    Updates,
    UserPlan,
    MyIcon,
  },
  computed: {
    ...mapState(["isMenuExpanded"]),
  },
  methods: {
    goToPlans() {
      const userInfo = JSON.parse(localStorage.getItem("token"));
      if (userInfo.init.appBarsOpacity.abr) {
        this.$router.push({
          name: "plans",
          query: { abr: userInfo.init.appBarsOpacity.abr },
        });
      } else {
        console.warn("No token found in localStorage");
      }
    },
    syncLayoutWidth() {
      // Tablet uses temporary overlay drawer (DrawerHover mobile branch) —
      // do not reserve desktop mini/full rail space or a right-side gap appears.
      if (this.isTablet) {
        document.documentElement.style.setProperty("--dynamic-width", "0px");
        return;
      }
      var dynamicWidth = this.$store.state.isMenuExpanded ? "200px" : "70px";
      document.documentElement.style.setProperty("--dynamic-width", dynamicWidth);
    },
    menuToggle() {
      // Same breakpoint as DrawerHover: tablet shows temporary mobile drawer.
      if (this.isTablet) {
        var next = !this.$store.state.isMobileMenuOpen;
        this.$store.commit("SET_MOBILE_MENU", next);
        this.isMenuToggle = next;
        this.syncLayoutWidth();
        return;
      }
      if (this.$store.state.isMenuExpanded) {
        this.$store.commit("SET_MENU_EXPANDED", false);
      } else {
        this.$store.commit("SET_MENU_EXPANDED", true);
      }
      this.syncLayoutWidth();
    },
    resize() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
    setToday() {
      var m = moment();
      if (this.$store.state.date_locale === "fa,en") {
        const shamsiYear = m.jYear();
        const shamsiMonth = m.jMonth() + 1;
        const shamsiDay = m.jDate();

        const persianMonths = [
          "فروردین",
          "اردیبهشت",
          "خرداد",
          "تیر",
          "مرداد",
          "شهریور",
          "مهر",
          "آبان",
          "آذر",
          "دی",
          "بهمن",
          "اسفند",
        ];

        this.today = `${shamsiDay}/${persianMonths[shamsiMonth - 1]}/${shamsiYear}`;
      }
      if (this.$store.state.date_locale === "en,fa") {
        this.today = m.format("YYYY/MM/DD");
      }
    },
    getYears() {
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "year",
            search: null,
            page: 1,
          },
        })
        .then((res) => {
          res = res.data;
          app.yearItems = res.data;
          app.allYears = res.data;
          if (
            app.allYears &&
            app.allYears.length > 0 &&
            app.$store &&
            app.$store.state.financialYear &&
            app.$store.state.financialYear.id === app.allYears[0].id
          ) {
            app.$store.commit("SET_ISMAINYEAR", true);
          } else {
            app.$store.commit("SET_ISMAINYEAR", false);
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false));
    },
    changeYear(item) {
      if (this.$store.state.financialYear.id === item.id) return false;
      var app = this;
      app.loading = true;
      app.$axios
        .get(this.$endpoint + "getdetail", {
          params: {
            select: "changeYear",
            year: item,
          },
        })
        .then((res) => {
          res = res.data;
          var storage = JSON.parse(localStorage.getItem("token"));
          storage.init.startDate = res.start_date;
          storage.init.endDate = res.end_date;
          storage.init.financialYear = res;
          storage.init.year = res.name;
          localStorage.setItem("token", JSON.stringify(storage));

          app.$store.commit("SET_YEAR", res.name);
          app.$store.commit("SET_FINANCIALYEAR", res);
          app.$store.commit("SET_START_DATE", res.start_date);
          app.$store.commit("SET_END_DATE", res.end_date);
          location.reload();
        })
        // eslint-disable-next-line handle-callback-err
        .catch((err) => {
          /* this.serverErrorHandeler(err) */
        })
        .finally(() => (app.loading = false));
    },
  },
  watch: {
    isMenuExpanded() {
      if (!this.isTablet) {
        this.isMenuToggle = !this.isMenuToggle;
        this.syncLayoutWidth();
      }
    },
    isTablet: {
      immediate: true,
      handler() {
        this.syncLayoutWidth();
        if (this.isTablet) {
          this.isMenuToggle = !!this.$store.state.isMobileMenuOpen;
        }
      },
    },
    "$store.state.isMobileMenuOpen"(val) {
      if (this.isTablet) {
        this.isMenuToggle = !!val;
      }
    },
    year(val) {
      this.changeYear(val);
    },
  },
  mounted() {
    this.setToday();
    this.getYears();
    this.syncLayoutWidth();
  },
};
</script>

<style>
.wrapper-app-bar {
  height: 50px !important;
  padding: 0 8px;
  position: fixed;
  z-index: 3;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 0%), 0px 4px 5px 0px rgb(0 0 0 / 0%),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
}
.wrapper-app-bar .wrapper-toolbar {
  position: absolute;
  width: calc(100% - var(--dynamic-width));
  transition: width 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
:root {
  --dynamic-width: 200px;
}
.wrapper-app-bar .wrapper-toolbar .toggle-icon {
  transition: transform 0.3s ease-in-out;
  transform: rotate(0deg);
}
.wrapper-app-bar .wrapper-toolbar .toggle-icon.rotate {
  transform: rotate(180deg);
}
.wrapper-app-bar .v-toolbar__content {
  height: 50px !important;
  width: 100%;
}
.wrapper-app-bar .wrapper-toolbar .vertical-divider {
  border: 0.01rem solid #f0eeee82;
  height: 40px;
}
</style>
